import {
  RecursivePartial,
  SiteAllowStringValues,
} from "@inrange/building-manager-api-client/models-site";
import deepmerge from "deepmerge";
import { parseAsNumber } from "./siteSections/utils";

export const overwriteMerge = (_destinationArray, sourceArray, _options) =>
  sourceArray;

export const applySiteUpdate = (
  prevSite: unknown,
  update: RecursivePartial<SiteAllowStringValues>,
  exemptPaths: string[] = [],
  pruneBlank: boolean = false
) => {
  const prevSiteCast = prevSite as SiteAllowStringValues;
  let siteUpdates = pruneEmpty(
    deepmerge(prevSiteCast, update, {
      arrayMerge: overwriteMerge,
    }),
    exemptPaths
  ) as unknown as SiteAllowStringValues;
  if (pruneBlank) {
    siteUpdates = pruneBlankStrings(siteUpdates) as SiteAllowStringValues;
  }
  const generations = siteUpdates.generation
    ? Object.values(siteUpdates.generation).filter((g) => !!g)
    : [];
  if (generations.length > 0) {
    const totalInstalledCapacity = generations.reduce(
      (acc, gen) => acc + parseAsNumber(gen?.installedCapacity),
      0
    );
    siteUpdates.totalInstalledCapacity = totalInstalledCapacity;
  }
  return siteUpdates;
};

export const pruneEmpty = (
  obj: any,
  exemptPaths: string[] = [],
  currentPath: string[] = []
): any => {
  if (exemptPaths.length === 0) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }

  const fullPath = currentPath.join(".");

  // If the current path is exactly in the exempt list, skip pruning
  if (exemptPaths.includes(fullPath)) {
    return obj;
  }

  const pruned: Record<string, any> = {};

  for (const [key, value] of Object.entries(obj)) {
    const childPath = [...currentPath, key];

    const prunedValue =
      typeof value === "object" && value !== null && !Array.isArray(value)
        ? pruneEmpty(value, exemptPaths, childPath)
        : value;

    if (prunedValue !== undefined && prunedValue !== "") {
      pruned[key] = prunedValue;
    }
  }

  return Object.keys(pruned).length > 0 ? pruned : undefined;
};

export const pruneBlankStrings = (
  obj: any
): RecursivePartial<SiteAllowStringValues> => {
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }

  const pruned: Record<string, any> = {};

  for (const [key, value] of Object.entries(obj)) {
    const prunedValue =
      typeof value === "object" && value !== null && !Array.isArray(value)
        ? pruneBlankStrings(value)
        : value;

    if (prunedValue !== undefined && prunedValue !== "") {
      pruned[key] = prunedValue;
    }
  }

  return pruned;
};
